module.exports = __webpack_public_path__ + "img/senha.890c0338.svg";